import React from 'react';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Chip from '@material-ui/core/Chip';
import { lighten } from '@material-ui/core/styles';
import { BACKGROUND_WHITE, BLACK_COLOR } from '../../../const/color-const';
import classNames from 'classnames';

const useStyles = makeStyles(theme => ({
  root: props => ({
    margin: theme.spacing(2),
    textAlign: 'left',
    width: 220,
    [theme.breakpoints.up('md')]: {
      width: props.wide ? 320 : 240,
    },
    '& label': {
      paddingRight: theme.spacing(5),
    },
  }),
  selectItem: {
    height: 60,
    backgroundColor: theme.palette.type === 'light' ? lighten(BACKGROUND_WHITE, 0.7) : BLACK_COLOR,
    width: '100%',
    '& > div': {
      padding: theme.spacing(1),
      [theme.breakpoints.up('md')]: {
        padding: theme.spacing(2, 1.5, 2, 1.5),
      },
    },
  },
  chips: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'nowrap',
    '& span': {
      padding: theme.spacing(0, 1, 0, 1),
    },
  },
  chip: {
    margin: 1,
    fontSize: 12,
    '&:only-child': {
      maxWidth: 'unset',
    },
    '&:not(only-child)': {
      maxWidth: 64,
    },
    [theme.breakpoints.up('md')]: {
      margin: 2,
      '&:not(only-child)': {
        maxWidth: 76,
      },
    },
  },
}));

const CommonMultiSelectField = (props) => {
  const {
    wide,
    options,
    field,
    form,
    label,
    onChange,
    atLeastOneElement,
    date,
    disabled,
    extraHandleChangeAction,
    endAdornment,
    ...rest
  } = props;
  const componentMeta = form.getFieldMeta(field.name);
  const isUpdated = (componentMeta.initialValue !== componentMeta.value) && form.dirty;
  const classes = useStyles({ wide: wide, disabled: disabled });
  
  function getTextFieldClassName(isUpdated, isDisabled) {
    return classNames({
      isUpdated: isUpdated,
      isDisabled: isDisabled,
    });
  }
  
  return (
    <FormControl variant="outlined"
                 className={`${classes.root} ${getTextFieldClassName(isUpdated, disabled)} MultiSelectField`}>
      
      <InputLabel>
        {label}
      </InputLabel>
      
      <Select
        disabled={disabled}
        className={`${classes.selectItem} ${getTextFieldClassName(isUpdated, disabled)} selectItem`}
        multiple
        variant="outlined"
        label={label}
        endAdornment={endAdornment}
        value={Array.isArray(field.value) ? field.value : []}
        renderValue={(selected) => {
          return <div className={classes.chips}>
            {selected.map((value) => (
              <Chip variant="outlined" key={value} label={options.find(option => option.value === value)?.label}
                    className={classes.chip} />
            ))}
          </div>;
        }}
        onChange={(event, lastSelected) => {
          if (extraHandleChangeAction) {
            extraHandleChangeAction();
          }
          if (!atLeastOneElement || event.target.value.length > 0) {
            if (lastSelected && lastSelected.props.value === null) {
              form.setFieldValue(field.name, [null]);
            } else {
              form.setFieldValue(field.name, event.target.value.filter(option => option !== null));
            }
          }
        }}
        MenuProps={{
          getContentAnchorEl: null,
          anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'left',
          },
        }}
      >
        {options.map((option, index) => (
          <MenuItem
            disabled={disabled}
            key={index}
            value={option.value}>
            {typeof option.label === 'function'
              ? option.label({ ...rest })
              : option.label}
          </MenuItem>
        ))}
      
      </Select>
    
    </FormControl>
  );
};

export default CommonMultiSelectField;